import { render, staticRenderFns } from "./v-upload.vue?vue&type=template&id=90d08c24&scoped=true&"
import script from "./v-upload.vue?vue&type=script&lang=js&"
export * from "./v-upload.vue?vue&type=script&lang=js&"
import style0 from "./v-upload.vue?vue&type=style&index=0&id=90d08c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d08c24",
  null
  
)

export default component.exports